export const imageTypes = [
  'image/jpeg',
  'image/png',
  'image/bmp',
  'image/tiff',
  'image/x-portable-pixmap',
];
